module.exports = __webpack_public_path__ + "static/c9-4e4754bcbfd36e548d91f506863cc553.jpg";